export const UserGQLSCHEMA = `
id
MainInfo {
  FullName
  LastName
}
Credentials {
  Email
}
`;
